import { useTrailerDetailsQuery } from '../graphql/TrailerDetails'

export const useTrailer = (trailerId: string) => {
  const { data: trailerDetailsData, error, loading } = useTrailerDetailsQuery({
    variables: {
      trailerId,
    },
  })

  return {
    trailerDetails: trailerDetailsData?.trailer,
    error,
    loading,
  }
}
